import { useQuery } from '@tanstack/react-query';
import { IListResponse } from '../../interfaces/listResponse';
import { IFreelancerSearchRequest, IFreelancerSearchResponse } from '../../interfaces/freelancerSearch';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { FreelancerService } from '../../services/freelancer';
import { parseAxiosError } from '../../services/axios';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { useNotification } from '../../+state/useNotification';

interface IProps extends IBaseUseQueryProps<IListResponse<IFreelancerSearchResponse>> {
  queryParamState: IFreelancerSearchRequest;
}

export const GET_FREELANCERS_LIST_QUERY_KEY = 'get-freelancers-list';

export const useGetFreelancersList = ({ queryParamState, onError, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery<IListResponse<IFreelancerSearchResponse>, AxiosError<IErrorResponse>>({
    queryKey: [GET_FREELANCERS_LIST_QUERY_KEY, queryParamState],
    queryFn: () => FreelancerService.getList(queryParamState),
    enabled: !!Object.keys(queryParamState).length,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      onError?.(err);
    },
    ...props
  });
};